export function initProductGradient(){
    const wrapper = document.querySelector<HTMLDivElement>('.product-advantages__wrapper');
    const scrollable = wrapper?.querySelector<HTMLDivElement>('.product-advantages__right');
    const topGradient = wrapper?.querySelector<HTMLDivElement>('.gradient.top');
    const bottomGradient = wrapper?.querySelector<HTMLDivElement>('.gradient.bottom');

    if (wrapper && scrollable && topGradient && bottomGradient) {
        const updateGradients = () => {
            const scrollTop = scrollable.scrollTop;
            const scrollHeight = scrollable.scrollHeight;
            const clientHeight = scrollable.clientHeight;

            // Плавная видимость через opacity
            topGradient.style.opacity = scrollTop > 0 ? '1' : '0';
            bottomGradient.style.opacity = scrollTop + clientHeight < scrollHeight ? '1' : '0';
        };

        scrollable.addEventListener('scroll', updateGradients);
        window.addEventListener('resize', updateGradients);
        updateGradients();
    }

}